module.exports = __webpack_public_path__ + "static/media/Streetlamp Effect - laura-ghise-2W7kYsPg6IU-unsplash.34db569d.jpg";